module.exports = __webpack_public_path__ + "img/co2.f264d13a.png";